// @ts-check
import { gql } from '@apollo/client/core';
import { Image, View } from '@react-pdf/renderer';
import React from 'react';
import { useProduct, useTheme } from './UrbanihofInfoSheet';

export default function UrbanihofInfoSheetPageHeader({ style, ...rest }) {
  const product = useProduct();
  return (
    <View style={[{ height: '30mm' }, style]} {...rest}>
      {product.producer?.logo?.fixed?.src && (
        <Image
          src={product.producer.logo.fixed.src}
          style={{
            width: '54mm',
            height: '30mm',
            objectFit: 'contain',
            objectPositionX: 'left',
            objectPositionY: 'top',
          }}
        />
      )}
    </View>
  );
}

UrbanihofInfoSheetPageHeader.fragment = gql`
  fragment UrbanihofInfoSheetPageHeader on Product {
    producer {
      logo {
        # 54mm * 2.54 / 72dpi * 300dpi - height is calculated automatically
        fixed(width: 571) {
          src
        }
      }
      # needed for apollo client
      producerId
    }
  }
`;
